import { FileStore } from './storage/FileStore';
import { SwimmerRepository } from './repositories/SwimmerRepository';
class DataStore {
    constructor() {
        const fileStore = FileStore.createInUserData('swimmers.json');
        this.swimmerRepository = new SwimmerRepository(fileStore);
        this.swimmerRepository.initialize().catch(err => {
            console.error('Failed to initialize swimmer repository:', err);
        });
    }
    async saveSwimmer(swimmerData) {
        return this.swimmerRepository.save(swimmerData);
    }
    async getAllSwimmers() {
        return this.swimmerRepository.findAll();
    }
    async getSwimmer(tiref) {
        return this.swimmerRepository.findByTiref(tiref);
    }
    async deleteSwimmer(tiref) {
        return this.swimmerRepository.deleteByTiref(tiref);
    }
    async saveCountyTimesStore(store) {
        const fileStore = FileStore.createInUserData('county-times.json');
        await fileStore.write(store);
    }
    async loadCountyTimesStore() {
        try {
            const fileStore = FileStore.createInUserData('county-times.json');
            return await fileStore.read();
        }
        catch {
            return {};
        }
    }
    async saveActiveStandards(active) {
        const fileStore = FileStore.createInUserData('active-standards.json');
        await fileStore.write(active);
    }
    async loadActiveStandards() {
        try {
            const fileStore = FileStore.createInUserData('active-standards.json');
            return await fileStore.read();
        }
        catch {
            return [];
        }
    }
    async saveSelectedStrokes(strokes) {
        const fileStore = FileStore.createInUserData('selected-strokes.json');
        await fileStore.write(strokes);
    }
    async loadSelectedStrokes() {
        try {
            const fileStore = FileStore.createInUserData('selected-strokes.json');
            return await fileStore.read();
        }
        catch {
            return [];
        }
    }
    async saveSelectedDistances(distances) {
        const fileStore = FileStore.createInUserData('selected-distances.json');
        await fileStore.write(distances);
    }
    async loadSelectedDistances() {
        try {
            const fileStore = FileStore.createInUserData('selected-distances.json');
            return await fileStore.read();
        }
        catch {
            return [];
        }
    }
    async replaceAllSwimmers(swimmers) {
        await this.swimmerRepository.replaceAll(swimmers);
    }
    async clear() {
        await this.swimmerRepository.clear();
        await FileStore.createInUserData('county-times.json').clear();
        await FileStore.createInUserData('active-standards.json').clear();
    }
}
export default DataStore;
